import React, { useMemo, useEffect, useState } from "react";
import { t } from "@lingui/macro";
import {
  InputGroup,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  InputGroupText,
  DropdownToggle
} from "reactstrap";
import { Checkbox } from "antd";

const NONE_VALUE = "--None--";

function MultiSelectDropdownField(props) {
  const {
    formData,
    formContext: { sideChannel },
    disabled,
    readonly: propReadonly,
    schema: { title, options },
    idSchema: { $id } = {},
    uiSchema: { "ui:readonly": uiReadonly },
    onChange
  } = props;

  const readonly = propReadonly || uiReadonly;

  const isDisabled = readonly || disabled;

  const [checked, setChecked] = useState(() => 
    formData ? formData.split(',').filter(Boolean) : []
  );

  useEffect(() => {
    const newChecked = formData ? formData.split(',').filter(Boolean) : [];
    setChecked(newChecked);
  }, [formData]);

  const optionsById = useMemo(() => {
      const map = {};
      (options || []).forEach(option => {
          if (Array.isArray(option)) {
              map[option[0]] = option[1];
          } else if (option && typeof option === 'object') {
              map[option.id] = option.label;
          } else {
              map[option] = option;
          }
      });
      return map;
  }, [options]);

  function isChecked(optionId) {
      return checked.indexOf(optionId) !== -1;
  }

  function toggleChecked(optionId) {
      setChecked(prevChecked => {
          const newChecked = [...prevChecked];
          const index = newChecked.indexOf(optionId);
          
          if (index > -1) {
              newChecked.splice(index, 1);
          } else {
              newChecked.push(optionId);
          }
          
          const result = newChecked.length > 0 ? newChecked.join(',') : null;
          onChange(result);
          return newChecked;
      });
  }

  const currentValue = useMemo(() => {
      if (checked.length > 0) {
          return checked.map(id => optionsById[id]).join(', ');
      }
      return null;
  }, [checked, optionsById])

  const renderOption = (option, ix, depth=0) => {
      const optionId = Array.isArray(option) ? option[0] : (option?.id || option);
      const optionLabel = Array.isArray(option) ? option[1] : (option?.label || option);
      
      return (
          <div key={`${optionId}-${ix}`} style={{ paddingLeft: 8 }}>
              <Checkbox
                  checked={isChecked(optionId)}
                  onChange={() => toggleChecked(optionId)}
              >
                  <div style={{ paddingLeft: 8 * depth }}>{optionLabel}</div>
              </Checkbox>
          </div>
      )
  }

  return (
    <div key={title}>
      <InputGroup className="filter-input-group">
        <InputGroupText className="filter-key">{title}</InputGroupText>
        <UncontrolledDropdown
          className="filter-dropdown-menu shadow-none"
          disabled={isDisabled}
        >
          <DropdownToggle className="shadow-none" caret>
            <span className="worktray-filters-btn-title">
              {currentValue || t`Select`}
            </span>
          </DropdownToggle>
          <DropdownMenu className="filter-dropdown-menu">
            <DropdownItem key={0} onClick={() => onChange(null)}>
              {NONE_VALUE}
            </DropdownItem>
            {(options || []).map((o, ix) => renderOption(o, ix))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </InputGroup>
    </div>
  );
}

export default MultiSelectDropdownField;